import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { getMenu } from 'src/api/getMenu';
import type { IMenu } from 'src/types/menu.types';
import { QueryKeys } from 'src/hooks/QueryKeys';
import { formatMenu } from './formatMenu/formatMenu';

export const useMenu = (menuId: string, options?: UseQueryOptions<IMenu>): UseQueryResult<IMenu> => {
  return useQuery<IMenu>({
    queryKey: [QueryKeys.menu, menuId],
    queryFn: async () => {
      const response = await getMenu(menuId);
      return formatMenu(response);
    },
    ...options,
  });
};
